import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@core/api/client'

export const demographicSocioeconomicGroupService = {
	/**
	 * Get all demographic socioeconomic groups
	 */
	getDemographicSocioeconomicGroups(
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.get('/types/demographicSocioeconomicGroups', config)
	},
}

export default demographicSocioeconomicGroupService
